// extracted by mini-css-extract-plugin
export default {"pkm":"PkmImage_pkm__NTIuP","shiny":"PkmImage_shiny__X9+DL"};